/** Class applied to a rendered inline comment mark - see `InlineComment.renderHTML`. */
export const INLINE_COMMENT_CLASS = 'InlineComment';

/**
 * Whether a DOM event happened on an inline comment.
 *
 * Clicking an inline comment opens its comment thread, so handlers outside the editor must
 * leave those clicks alone rather than treating them as clicks on the surrounding element.
 */
export const isEventOnInlineComment = (target: EventTarget | null): boolean =>
    target instanceof Element && !!target.closest(`.${INLINE_COMMENT_CLASS}`);
